export const checkOutConfig = [
  {
    breadCrumbTitle: 'common.checkout_multi_paymentType',
    urlHash: 'customerInformation',
  },
  {
    breadCrumbTitle: 'common.checkout_multi_deliveryMethod',
    urlHash: 'deliveryMethod',
  },
  {
    breadCrumbTitle: 'common.checkout_summary_shippingAddress',
    urlHash: 'shippingAddress',
  },
  {
    breadCrumbTitle: 'common.checkout_summary_reviewYourOrder',
    urlHash: 'reviewYourOrder',
  },
];
